export enum RouteLineType {
  EMERGENCY_SERVICES = 'EMERGENCY_SERVICES',
  STRATEGY_PREFERRED = 'STRATEGY_PREFERRED',
  STRATEGY_AVOID = 'STRATEGY_AVOID',
}
